import { CountryIconProps } from './types';

const UG = ({ dimension }: CountryIconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_1046_3719)">
      <path
        d="M20.9434 20.0001C22.8439 17.8771 24 15.0739 24 12.0002C24 8.92648 22.8438 6.12321 20.9434 4.00015L12 3.13062L3.05662 4.00015C1.15617 6.12321 0 8.92648 0 12.0002C0 15.0739 1.15613 17.8771 3.05658 20.0001L12 20.8697L20.9434 20.0001Z"
        fill="#FFDA44"
      />
      <path
        d="M3.05664 4.00047H20.9434C18.7462 1.54577 15.5537 0.000488281 12 0.000488281C8.44628 0.000488281 5.25386 1.54577 3.05664 4.00047Z"
        fill="black"
      />
      <path
        d="M0 12.0008L12 13.0442L24 12.0008C24 10.5981 23.7585 9.25192 23.3162 8.00073H0.683812C0.241453 9.25192 0 10.5981 0 12.0008Z"
        fill="#D80027"
      />
      <path
        d="M0.683812 15.9993H23.3163C23.7585 14.7481 24 13.402 24 11.9993H0C0 13.402 0.241453 14.7481 0.683812 15.9993Z"
        fill="black"
      />
      <path
        d="M20.9435 19.9995H3.05664C5.25386 22.4543 8.44628 23.9995 12.0001 23.9995C15.5538 23.9995 18.7463 22.4543 20.9435 19.9995Z"
        fill="#D80027"
      />
      <path
        d="M16.0038 12.0007C16.0038 14.2124 14.2112 16.005 11.9995 16.005C9.78776 16.005 7.99512 14.2124 7.99512 12.0007C7.99512 9.78898 9.78776 7.99634 11.9995 7.99634C14.2112 7.99634 16.0038 9.78898 16.0038 12.0007Z"
        fill="#F0F0F0"
      />
      <path
        d="M13.4669 12.2036L11.9999 11.568C11.9999 11.568 12.3431 10.4288 12.3614 10.3508C12.3748 10.2939 12.3819 10.2345 12.3819 10.1734C12.3819 9.9573 12.2943 9.76164 12.1526 9.62008L12.5215 9.25117C12.2855 9.01516 11.9594 8.86914 11.5992 8.86914C11.239 8.86914 10.9129 9.01511 10.6769 9.25117L11.0458 9.62008C10.9042 9.76169 10.8166 9.95734 10.8166 10.1734C10.8166 10.2525 10.8285 10.3286 10.8503 10.4006L10.2949 10.956H11.3044C11.3044 10.956 10.887 11.5829 10.6592 12.0977C10.4313 12.6125 10.6623 13.2409 11.1889 13.475L11.4934 13.6104L11.9999 14.0864V14.6081L11.4782 15.1299H12.5217V14.0864L12.9978 13.6103H13.9825C13.9873 13.6005 13.9922 13.5909 13.9967 13.5809C14.2307 13.0543 13.9935 12.4376 13.4669 12.2036Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1046_3719">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
export default UG;
